const MallList = () => import("@/views/mall/pc/list.vue");
const MallSingle = () => import("@/views/mall/pc/single.vue");
const MallMobileList = () => import("@/views/mall/m/list.vue");
const MallMobileSingle = () => import("@/views/mall/m/single.vue");
const MallMobileCart = () => import("@/views/mall/m/cart.vue");
const MallMobileFav = () => import("@/views/mall/m/fav.vue");

import layout from "@/layouts/dashboard";
const DefaultLayout = () => import("@/layouts/default.vue");

export default [
    {
        path: "/mall/pc",
        name: "mall-pc",
        component: layout,
        children: [
            // 商品列表
            {
                path: "list",
                name: "mall-pc-list",
                component: MallList,
                meta: {
                    titleKey: "mall.route.title",
                    descKey: "mall.route.desc",
                },
            },
            {
                path: "single/:uuid",
                name: "mall-pc-single",
                component: MallSingle,
                meta: {
                    titleKey: "mall.route.title",
                    descKey: "mall.route.desc",
                },
            },
        ],
    },
    {
        path: "/mall/m",
        name: "mall-m",
        component: DefaultLayout,
        children: [
            // 商品列表
            {
                path: "list",
                name: "mall-m-list",
                component: MallMobileList,
                meta: {
                    titleKey: "mall.route.title",
                },
            },
            {
                path: "single/:uuid",
                name: "mall-m-single",
                component: MallMobileSingle,
                meta: {
                    titleKey: "mall.route.title",
                },
            },
            // 购物车
            {
                path: "cart",
                name: "mall-m-cart",
                component: MallMobileCart,
                meta: {
                    titleKey: "mall.cart.title",
                },
            },
            // 收藏夹
            {
                path: "fav",
                name: "mall-m-fav",
                component: MallMobileFav,
                meta: {
                    titleKey: "mall.fav.title",
                },
            },
        ],
    },
];
